import CoursesApiService from "./api/CoursesApiService";
import { formatPayloadToQueryString } from "@/utils/formatters";
export const getClassrooms = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.get(`/classrooms${formatPayloadToQueryString(payload)}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar turmas', error);
        throw error;
    }
};
export const getClassroomById = async (classroomId, userToken) => {
    try {
        const response = await CoursesApiService.get(`/classrooms/${classroomId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao buscar turma', error);
        throw error;
    }
};
export const createClassroom = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/classrooms', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao criar turma', error);
        throw error;
    }
};
export const updateClassroom = async (payload, userToken) => {
    const { id, ...classroom } = payload;
    try {
        const response = await CoursesApiService.put(`/classrooms/${id}`, classroom, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao atualizar turma', error);
        throw error;
    }
};
export const deleteClassroom = async (classroomId, userToken) => {
    try {
        await CoursesApiService.delete(`/classrooms/${classroomId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    }
    catch (error) {
        console.error('Erro ao deletar turma', error);
        throw error;
    }
};
export const createClassroomSetting = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/classroom-settings', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao salvar configurações da turma', error);
        throw error;
    }
};
export const updateClassroomSetting = async (payload, userToken) => {
    const { id, ...setting } = payload;
    try {
        const response = await CoursesApiService.put(`/classroom-settings/${id}`, setting, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    }
    catch (error) {
        console.error('Erro ao atualizar configurações da turma', error);
        throw error;
    }
};
export default {
    getClassrooms,
    getClassroomById,
    createClassroom,
    updateClassroom,
    deleteClassroom,
    createClassroomSetting,
    updateClassroomSetting
};
